import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "update-expense-modal"
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Edit Pendapatan Lain-Lain", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Jadwal", -1)
const _hoisted_6 = { class: "text-2xl font-bold mb-4" }
const _hoisted_7 = { class: "rounded-xl border-grey-2 p-5 mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-10 gap-4 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-base font-normal" }, "Jenis Pendapatan"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-base font-normal" }, "Jumlah"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-base font-normal" }, "Nominal")
], -1)
const _hoisted_9 = { class: "col-span-3 text-base font-semibold text-grey" }
const _hoisted_10 = { class: "col-span-3" }
const _hoisted_11 = { class: "p-inputgroup flex-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Orang", -1)
const _hoisted_13 = { class: "col-span-4" }
const _hoisted_14 = { class: "p-inputgroup flex-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_16 = { class: "flex items-center pt-5" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "approve-modal",
          showHeader: true,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '60vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
                })
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Button, {
                class: "btn-back mr-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSubmit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.TrxId), 1),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataSource, (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "grid grid-cols-10 gap-4 py-3 border-top-grey-lighten-5",
                    key: field.idType
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(field.RevenueName), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_InputNumber, {
                          modelValue: field.Quantity,
                          "onUpdate:modelValue": ($event: any) => ((field.Quantity) = $event),
                          placeholder: "0",
                          min: 0,
                          max: 99999999.99,
                          step: 0.25
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "step"]),
                        _hoisted_12
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_InputNumber, {
                          modelValue: field.Value,
                          "onUpdate:modelValue": ($event: any) => ((field.Value) = $event),
                          placeholder: "0",
                          min: 0,
                          max: 99999999.99,
                          step: 0.25
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "step"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}